'use es6';

export const SECOND = 1000;
export const REDIRECT_DELAY_IN_SECONDS = 3;